import { createAsyncThunk } from '@reduxjs/toolkit';
import { SuggestedFaqAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { IGetSuggestedFaqsDTO, IGetSuggestedFaqsResponse } from '@/models/suggestedFaq.model';
import { SLICE_NAME } from './models';

export const getSuggestedFaqs = createAsyncThunk<
  IGetSuggestedFaqsResponse,
  IGetSuggestedFaqsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getSuggestedFaqs`,
  async (params) => {
    const response = await SuggestedFaqAPI.getSuggestedFaqs(params);
    return response.data;
  },
  { serializeError: formatApiError },
);
